var map = {
	"./appocrate-doctolib.png": 2769,
	"./dema-example.png": 4643,
	"./index.jpg": 845,
	"./logo-PNRR.png": 5244,
	"./logo-doctolib-blue.svg": 2191,
	"./logo-doctolib-hos.png": 8322,
	"./logo-doctolib.svg": 2378,
	"./logo.png": 4427,
	"./rossa-example.png": 1492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;